export * from './baSidebar.component';



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/baSidebar/index.ts